<template>
  <v-app light>
    <v-progress-linear
      :indeterminate="loading"
      height="2"
      color="orange"
      style="margin: 0;z-index: 9999;position: fixed;"
    />
    <router-view/>
  </v-app>
</template>

<script>
  // import Web from '@/components/Web'

  export default {
    components: {},
    data() {
      return {
        name: 'App',
        loading: false
      }
    },

    created() {
      this.$router.beforeEach(
        (to, from, next) => {
          this.loading = true;
          next();
        });

      this.$router.afterEach(
        () => {
          this.loading = false;
        });
    }
  }
</script>
<style>
  .application {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }
</style>
